export default class FilterTagsList extends React.Component {
  constructor(props) {
    super(props);
    this.filter = this.filter.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.renderTags = this.renderTags.bind(this);
    this.handleRemoveShoreDistance = this.handleRemoveShoreDistance.bind(this);
    this.handleRemoveDistance = this.handleRemoveDistance.bind(this);
    this.priceString = this.priceString.bind(this);
    this.areaCenterDefaultDistance = this.props.data.default_distance || this.props.data.max_distance;
  }

  filter(key, value) {
    const filters = { ...this.props.filters, [key]: value };
    this.props.filter(filters);
  }

  handleRemove(id, enabled_ids, condition_param) {
    const newEnabledIds = enabled_ids.filter((item) => item !== id);
    this.filter(condition_param, newEnabledIds);
  }

  handleRemoveShoreDistance() {
    this.filter('shoreDistance', 0);
  }

  handleRemovePrices() {
    this.filter('prices', [0, this.props.price_max_end]);
  }

  handleRemoveDistance() {
    this.filter('distance', this.areaCenterDefaultDistance);
  }

  handleRemoveRecovery() {
    this.filter('recovery', this.recovery);
  }

  renderTags(elements_ids, elements, condition_param) {
    if (!elements) return '';

    return (
      elements_ids instanceof Array &&
      elements_ids.map((id) => (
        <div
          className='filter-tags-list__tag filter-tags-list__tag_prevent-remove'
          onClick={() => this.handleRemove(id, elements_ids, condition_param)}
          key={id}
        >
          {elements.find((tag) => tag.id == id)?.name}
        </div>
      ))
    );
  }

  priceString() {
    const start = Math.floor(this.props.filters.prices[0]);
    const end = Math.floor(this.props.filters.prices[1]);
    const start_string = start > 0 ? `от ${start}` : '';
    const end_string = end < this.props.price_max_end ? `до ${end}` : '';
    return `${start_string} ${end_string}`;
  }

  render() {
    let shoreDistance = this.props.filters.shoreDistance;
    const areaCenterNotDefault =
      this.props.filters.distance && this.props.filters.distance !== this.areaCenterDefaultDistance;

    const hasActiveFilters = () => {
      const filters = this.props.filters;

      return (
        (Array.isArray(filters.prices) && (filters.prices[0] > 0 || filters.prices[1] < this.props.price_max_end)) ||
        (filters.shoreDistance && filters.shoreDistance > 0) ||
        (filters.distance && filters.distance !== this.areaCenterDefaultDistance) ||
        Object.entries(filters)
          .filter(([key]) => !['less_capacity', 'all_categories', 'prices', 'not_required_prepayment'].includes(key))
          .some(([, filter]) => Array.isArray(filter) && filter.length > 0)
      );
    };

    return (
      <div className={`filter-tags-list ${this.props.campsLoaded ? '' : 'filter-tags-list-loading'}`}>
        {this.props.is_desktop && hasActiveFilters() && (
          <div className='filter-search-none__btn'>
            <button className='filter-search-none__btn__text' onClick={this.props.resetFilter}>
              Сбросить всё
            </button>
          </div>
        )}

        {this.props.filters.prices instanceof Array &&
        (this.props.filters.prices[0] > 0 || this.props.filters.prices[1] < this.props.price_max_end) ? (
          <div className='filter-tags-list__tag' onClick={() => this.handleRemovePrices()} key='prices'>
            Цена {this.priceString()} ₽
          </div>
        ) : (
          ''
        )}

        {shoreDistance === false || shoreDistance.length === 0 || shoreDistance === 0 ? (
          ''
        ) : (
          <div className='filter-tags-list__tag' onClick={this.handleRemoveShoreDistance} key='-2'>
            До {this.props.data.shore_distances[this.props.filters.shoreDistance - 1]} м до берега
          </div>
        )}

        {areaCenterNotDefault ? (
          <div className='filter-tags-list__tag' onClick={this.handleRemoveDistance} key='-1'>
            От {this.props.data.city_name_genitive ?? this.props.data.area_center} {this.props.filters.distance} км
          </div>
        ) : (
          ''
        )}

        {this.renderTags(this.props.filters.recovery, this.props.data.recovery, 'recovery')}

        {this.renderTags(this.props.filters.shoreDistance, this.props.data.shore_distances, 'shoreDistance')}

        {this.renderTags(this.props.filters.waters, this.props.data.waters, 'waters')}

        {this.renderTags(this.props.filters.categories, this.props.data.category_list, 'categories')}

        {this.renderTags(
          this.props.filters.all_enabled_categories,
          this.props.data.all_category_list,
          'all_enabled_categories'
        )}

        {this.renderTags(this.props.filters.foodTypes, this.props.data.food_types, 'foodTypes')}

        {this.renderTags(this.props.filters.shoreDistance, this.props.data.shore_distances, 'shoreDistance')}

        {this.renderTags(this.props.filters.campLocations, this.props.data.camp_locations, 'campLocations')}

        {this.renderTags(this.props.filters.campPromotions, this.props.data.camp_promotions, 'campPromotions')}

        {this.renderTags(
          this.props.filters.campServiceTags,
          this.props.user_show_filter
            ? this.props.data.camp_service_tags_for_manager
            : this.props.data.camp_service_tags,
          'campServiceTags'
        )}

        {this.renderTags(
          this.props.filters.suitableTagsForRecovery,
          this.props.user_show_filter
            ? this.props.data.suitable_tags_for_recovery_for_manager
            : this.props.data.suitable_tags_for_recovery,
          'suitableTagsForRecovery'
        )}

        {this.renderTags(
          this.props.filters.apartmentServiceTags,
          this.props.data.apartment_service_tags,
          'apartmentServiceTags'
        )}

        {this.renderTags(
          this.props.filters.campTreatmentFactors,
          this.props.data.treatment_profiles_tags,
          'campTreatmentFactors'
        )}

        {this.renderTags(this.props.filters.childcareTags, this.props.data.childcare_tags, 'childcareTags')}

        {this.renderTags(
          this.props.filters.campTreatmentProfiles,
          this.props.data.deceases_list_for_filter,
          'campTreatmentProfiles'
        )}

        {this.renderTags(this.props.filters.stars, this.props.data.stars, 'stars')}

        {this.renderTags(this.props.filters.tags_properties, this.props.data.tag_properties_list, 'tags_properties')}

        {this.renderTags(
          this.props.filters.swimming_pools_properties,
          this.props.data.pools_tag_properties_list,
          'swimming_pools_properties'
        )}

        {this.renderTags(this.props.filters.bathTags, this.props.data.camp_bathhouses, 'bathTags')}
        {this.renderTags(this.props.filters.discount, this.props.data.discount, 'discount')}
        {this.renderTags(
          this.props.filters.notRequiredPrepayment,
          this.props.data.notRequiredPrepayment,
          'notRequiredPrepayment'
        )}
        {this.renderTags(this.props.filters.singleRoom, this.props.data.singleRoom, 'singleRoom')}
        {this.renderTags(this.props.filters.instant, this.props.data.instant, 'instant')}
      </div>
    );
  }
}
